import { render, staticRenderFns } from "./NavigationDrawerComponent.vue?vue&type=template&id=2983d090&scoped=true"
import script from "./NavigationDrawerComponent.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerComponent.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerComponent.vue?vue&type=style&index=0&id=2983d090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983d090",
  null
  
)

export default component.exports